module.exports = "<div class=\"mdl-grid\">\n  <div class=\"mdl-cell mdl-cell--12-col\">\n    <my-plot \n      [insert_x]=\"insertData.parameterisation.insert.x\"\n      [insert_y]=\"insertData.parameterisation.insert.y\"\n      [circle]=\"insertData.parameterisation.circle\"\n      [ellipse]=\"insertData.parameterisation.ellipse\">\n    </my-plot>\n  </div>\n  <div class=\"mdl-cell mdl-cell--12-col\">\n    <mdl-table mdl-shadow=\"2\"\n      [table-model]=\"tableModel\">\n    </mdl-table>\n  </div>\n</div>\n\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/dicom-components/send-to-parameterisation.component.html
 ** module id = 212
 ** module chunks = 0
 **/